export default "__VITE_ASSET__C9$3vCYs__"